module.exports = __webpack_public_path__ + "static/naplata-df47ad504cae51cb77b1a776f2f134ef.svg";